export default "__VITE_ASSET__DPaS64rA__"